import React, { useEffect, useState } from "react";
import Sketch from "react-p5";
import { v4 as uuid } from 'uuid';
import { DEFAULT_MAPPING, DENSITY_MAPPINGS, FONT } from "./AsciiArt";
import "./p5.css";

export default function AsciiVideo({densityMappingName}) {
  const [canvas, setCanvas] = useState(<></>);
  useEffect(() => {
    const densityMapping = densityMappingName ? DENSITY_MAPPINGS[densityMappingName] : DENSITY_MAPPINGS[DEFAULT_MAPPING];
    setCanvas(<AsciiArtCanvas key={uuid()} densityMapping={densityMapping} />);

    return (() => {
      setCanvas(<></>)
    })
  }, [densityMappingName]);

  return canvas;
}

function AsciiArtCanvas(props) {
  const [video, setVideo] = useState();
  const [asciiDiv, setAsciiDiv] = useState();
  const [isPaused, setIsPaused] = useState(false);

  function setup(p5, parent) {
    const screenWidth = p5.windowWidth;
    const screenHeight = p5.windowHeight;
    const charWidth = 10; // hard coded; seems about right
    const charHeight = 26; // hard coded; seems about right

    p5.noCanvas();
    const newVideo = p5.createCapture(p5.VIDEO);
    newVideo.parent(parent);
    newVideo.size(screenWidth / charWidth, screenHeight / charHeight);
    const newAsciiDiv = p5.createDiv();
    newAsciiDiv.parent(parent);
    newAsciiDiv.style("font-family", FONT);
    newAsciiDiv.style("color", "#fff");
    newAsciiDiv.style("background-color", "#000");
    newAsciiDiv.style("z-index", 0);
    newAsciiDiv.style("margin-top", "48px");
    newVideo.hide();

    setVideo(newVideo);
    setAsciiDiv(newAsciiDiv);
  };

  function draw(p5) {
    video.loadPixels();
    let asciiImage = "";
    for (let j = 0; j < video.height; j++) {
      for (let i = 0; i < video.width; i++) {
        const column = props.densityMapping.flip ? video.width - 1 - i : i;
        const pixelIndex = (column + j * video.width) * 4;
        const r = video.pixels[pixelIndex + 0];
        const g = video.pixels[pixelIndex + 1];
        const b = video.pixels[pixelIndex + 2];
        const averageBrightness = (r + g + b) / 3;
        const charIndex = p5.floor(
          p5.map(averageBrightness, 0, 255, props.densityMapping.alphabet.length, 0)
        );
        const charToAdd = props.densityMapping.alphabet.charAt(charIndex);
        charToAdd === " " ? (asciiImage += "\xa0") : (asciiImage += charToAdd);
      }
      asciiImage += "<br/>";
      asciiDiv.html(asciiImage);
    }
  };

  function mousePressed() {
    if (isPaused) {
      setIsPaused(false);
      video.play();
    } else {
      setIsPaused(true);
      video.stop();
    }
  }

  return <Sketch setup={setup} draw={draw} mousePressed={mousePressed} />;
}